import { isValidEmail } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import {
  invalidEmail,
  optionalDialCode,
  optionalPhoneNumber,
  phoneValidation,
  requiredMessage,
} from '@/utils/zodUtils';

export const DistributionFormSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      activeMethods: z.object({
        email: z.boolean().optional(),
        sms: z.boolean().optional(),
      }),
      email: z.string().optional(),
      dialCode: optionalDialCode,
      phoneNumber: optionalPhoneNumber,
    })
    .refine((data) => !(data.activeMethods.sms && (!data.dialCode || !data.phoneNumber)), {
      ...requiredMessage(t),
      path: ['phoneNumber'],
    })
    .refine((data) => (data.activeMethods.sms ? phoneValidation(data) : true), {
      message: t('INVALID_PHONE_NUMBER'),
      path: ['phoneNumber'],
    })
    .refine((data) => !(data.activeMethods.email && !data.email), {
      ...requiredMessage(t),
      path: ['email'],
    })
    .refine((data) => (data.activeMethods.email && data.email ? isValidEmail(data.email) : true), {
      ...invalidEmail(t),
      path: ['email'],
    });
